<ds-modal>
  <ds-modal-header [hideCloseButton]="true">
    <div class="header">
      <h3 class="text-center m-0" i18n="@@payment_method.label.complete_order">Ihre Bestellung abschließen</h3>
    </div>
  </ds-modal-header>
  <div class="payment-modal-content" [class.disabled]="processingOrder()">
    <span
      class="gapay-modal-description"
      i18n="@@payment_method.label.redirect_paypal"
      *ngIf="paymentMethodType === 'PAYPAL'"
      >Sie werden zu PayPal weitergeleitet, um Ihre Bestellung abzuschließen.</span
    >
    <span
      class="gapay-modal-description"
      i18n="@@payment_method.label.redirect_googlepay"
      *ngIf="paymentMethodType === 'GOOGLE_PAY'"
      >Sie werden zu Google Pay weitergeleitet, um Ihre Bestellung abzuschließen.</span
    >
    <span
      class="gapay-modal-description"
      i18n="@@payment_method.label.redirect_applepay"
      *ngIf="paymentMethodType === 'APPLE_PAY'"
      >Sie werden zu Apple Pay weitergeleitet, um Ihre Bestellung abzuschließen.</span
    >
    <div class="payment-button-wrapper">
      <button
        type="button"
        class="ds-button secondary mr-2"
        (click)="closeDialog()"
        i18n="@@button.cancel"
        [disabled]="processingOrder()"
      >
        Cancel
      </button>
      <div [id]="buttonId" class="payment-button" [class.loading]="processingOrder()"></div>
    </div>
  </div>

  <div class="loading-overlay" *ngIf="processingOrder()" aria-live="polite">
    <mat-spinner color="primary"></mat-spinner>
    <span i18n="@@payment_method.label.process_payment">Bearbeitung Ihrer Zahlung...</span>
  </div>
</ds-modal>
